import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
  PaginationComponent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@folio/components';
import { ErrorRow } from '@folio/components/module-elements/ErrorRow';
import { LoadingRow } from '@folio/components/module-elements/LoadingRow';
import { useCurrentPage } from '@folio/hooks/useCurrentPage';
import { useAssertedParams } from '@folio/lib';
import { useQuery } from '@tanstack/react-query';
import { brokerControllerListBrokersQueryOptions } from 'korint-sdk';
import { useTranslation } from 'react-i18next';

const PAGE_SIZE = 10;

export function RetailIntermediaryUsersListModule() {
  const { t } = useTranslation();
  const currentPage = useCurrentPage();

  const { brokerageFirmId } = useAssertedParams();

  const { data: brokers, status } = useQuery({
    ...brokerControllerListBrokersQueryOptions(brokerageFirmId!, {
      count: PAGE_SIZE,
      page: currentPage,
    }),
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('intermediaryUsersList.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t('fields.email.label')}</TableHead>
              <TableHead>{t('fields.firstName.label')}</TableHead>
              <TableHead>{t('fields.lastName.label')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {status === 'pending' ? (
              // biome-ignore lint/suspicious/noArrayIndexKey: It's all we have here and we don't really care in this case.
              Array.from({ length: PAGE_SIZE }).map((_, idx) => <LoadingRow key={idx} />)
            ) : status === 'error' ? (
              <ErrorRow />
            ) : (
              brokers.data.map(broker => (
                <TableRow key={broker.userId}>
                  <TableCell>{broker.email}</TableCell>
                  <TableCell>{broker.firstName}</TableCell>
                  <TableCell>{broker.lastName}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
      <CardFooter>
        <PaginationComponent
          totalData={brokers?.totalCount ?? 0}
          PAGE_SIZE={PAGE_SIZE}
          isLoading={status === 'pending'}
        />
      </CardFooter>
    </Card>
  );
}
